import Container from '../../@common.blocks/Container';
import Title from '../../@common.blocks/Title/index';
import Text from '../../@common.blocks/Text/index';
import { HashLink } from 'react-router-hash-link';
import Electro1 from '../../pictures/electro01.jpeg';
import Electro2 from '../../pictures/electro2.jpeg';
import Electro3 from '../../pictures/electro3.jpeg';
import Button from '../../@common.blocks/Button/index';
import '../SectionMainServices/section-main-services.css';

const SectionMainServices = () => {
  return (
    <div className="section-main-services">
      <Container>
        <div className="section-main-services__wrapper">
          <Title level="2" size="veryBg">
            Наши работы
          </Title>
          <div className="section-main-services__wrapper-listcards">
            <div className="section-main-services__wrapper-card">
              <div
                className="section-main-services__wrapper-minicard "
                id="serviceCard"
              >
                <div className="section-main-services__wrapper-picture">
                  <img src={Electro1} alt="" />
                </div>
                <div>
                  <div className="section-main-services__wrapper-text">
                    <Text component="p" section="cardhome">
                      Шкаф управления пожарной насосной станцией с
                      преобразователями частоты Danfoss и контроллером
                      управления Shinder Electric
                    </Text>
                  </div>
                  <HashLink to="/services#redcupboard">Узнать больше</HashLink>
                </div>
              </div>
            </div>
            <div className="section-main-services__wrapper-card">
              <div
                className="section-main-services__wrapper-minicard"
                id="serviceCard"
              >
                <div className="section-main-services__wrapper-picture">
                  <img src={Electro2} alt="" />
                </div>
                <div>
                  <div className="section-main-services__wrapper-text">
                    <Text component="p" section="cardhome">
                      В силовом шкафу установлен комплектный блок АВР
                      производства CHINT. Также применялись комплектующие таких
                      фирм как CHINT, IEK, DKC..
                    </Text>
                  </div>
                  <HashLink to="/services#cupboard_ABP">Узнать больше</HashLink>
                </div>
              </div>
            </div>
            <div className="section-main-services__wrapper-card">
              <div
                className="section-main-services__wrapper-minicard "
                id="serviceCard"
              >
                <div className="section-main-services__wrapper-picture">
                  <img src={Electro3} alt="" />
                </div>
                <div>
                  <div className="section-main-services__wrapper-text">
                    <Text component="p" section="cardhome">
                      Шкаф автоматики и управления конвейерными лентами c
                      контроллером управления Siemens S7-1200 с модулем
                      расширения дискретных входов/выходов...
                    </Text>
                  </div>
                  <HashLink to="/services#cupboard_ribbon">
                    Узнать больше
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
          <Button color="orange">
            <HashLink to="/services" id="link">
              Узнать подробнее об услугах
            </HashLink>
          </Button>
        </div>
      </Container>
    </div>
  );
};
export default SectionMainServices;
